// Reimbursement Manage Flow
export const REIMBURSEMENT_MANAGE_FLOW_SET_STEP = 'REIMBURSEMENT_MANAGE_FLOW_SET_STEP';
export const REIMBURSEMENT_MANAGE_FLOW_SET_PROP = 'REIMBURSEMENT_MANAGE_FLOW_SET_PROP';
export const REIMBURSEMENT_MANAGE_FLOW_SET_UNSAVED_CHANGES = 'REIMBURSEMENT_MANAGE_FLOW_SET_UNSAVED_CHANGES';
export const REIMBURSEMENT_MANAGE_FLOW_CLEAR = 'REIMBURSEMENT_MANAGE_FLOW_CLEAR';
export const REIMBURSEMENT_MANAGE_FLOW_SET_ERRORS = 'REIMBURSEMENT_MANAGE_FLOW_SET_ERRORS';
export const REIMBURSEMENT_MANAGE_FLOW_CLEAR_ERROR = 'REIMBURSEMENT_MANAGE_FLOW_CLEAR_ERROR';
export const REIMBURSEMENT_MANAGE_FLOW_CLEAR_ERRORS = 'REIMBURSEMENT_MANAGE_FLOW_CLEAR_ERRORS';

// Users Step
export const REIMBURSEMENT_MANAGE_FLOW_ADD_USER = 'REIMBURSEMENT_MANAGE_FLOW_ADD_USER';
export const REIMBURSEMENT_MANAGE_FLOW_ADD_USERS = 'REIMBURSEMENT_MANAGE_FLOW_ADD_USERS';
export const REIMBURSEMENT_MANAGE_FLOW_REMOVE_USER = 'REIMBURSEMENT_MANAGE_FLOW_REMOVE_USER';
export const REIMBURSEMENT_MANAGE_FLOW_REMOVE_ALL_USERS = 'REIMBURSEMENT_MANAGE_FLOW_REMOVE_ALL_USERS';

// Config Step
export const REIMBURSEMENT_MANAGE_FLOW_SET_CONFIG = 'REIMBURSEMENT_MANAGE_FLOW_SET_CONFIG';
